import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  #showFooter: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private viewportScroller: ViewportScroller) { }

  getShowFooter(): Observable<boolean> {
    return this.#showFooter.asObservable();
  }

  setShowFooter(show: boolean) {
    this.#showFooter.next(show);
  }

  setScrollOffset(xOffset: number = 0, yOffset: number = 0) {
    this.viewportScroller.setOffset([xOffset, yOffset]);
  }

  resetScrollOffset(){
    this.viewportScroller.setOffset([0, 0]);
  }

  scrollToAnchor(anchor: string){
    this.viewportScroller.scrollToAnchor(anchor);
  }
}
